<template>
  <h3 class="text-left text-sm font-semibold text-headline">
    <slot></slot>
  </h3>
</template>
